(() => {
  const launcher=document.currentScript;
  const src=launcher?.dataset.showroomSrc;
  const target=document.querySelector('#storyModelDock') || document.querySelector('.hero:not([hidden]) #heroModelDock');
  if(!src || !target) return;
  let loaded=false;
  const load=()=>{
    if(loaded) return;
    loaded=true;
    const script=document.createElement('script');
    script.src=src;
    script.async=true;
    document.body.appendChild(script);
  };
  if('IntersectionObserver' in window){
    const observer=new IntersectionObserver(entries=>{
      if(entries.some(e=>e.isIntersecting)){observer.disconnect();load();}
    },{rootMargin:'900px 0px'});
    observer.observe(target);
  }else load();
})();
